import { apiVersion } from '../../versions'
import { Dispatch } from 'redux'
import axios from 'axios'
import { alertErrorMessage, throwSuccessMessage } from '../../utils/Errors'
import { ILogFile, LogsActions } from '../../types/logs'
import { getHeaders } from './http'
import fileDownload from 'js-file-download'
import { IRenderPeriod, Period } from '../../components/modals/LogsModal/utils'

const API = `/api/${apiVersion}/logs`

export const fetchLogs = (): any => async (dispatch: Dispatch<any>) => {
    try {
        const { data } = await axios.get(API, { headers: getHeaders() })

        dispatch({
            type: LogsActions.FETCH_LOGS_LIST_SUCCESS,
            payload: data,
        })
    } catch (e) {
        alertErrorMessage(e);
        // throwErrorMessage(e.response?.data?.message, e.response?.status)
    }
}

export const prepareLogs =
    (guid: string, datesToRender: IRenderPeriod, datesToSend: Period): any =>
    async (dispatch: Dispatch<any>) => {
        try {
            const res = await axios.post(`${API}/${guid}/request`, datesToSend, {
                headers: getHeaders(),
            })

            if (res.status === 204) {
                throwSuccessMessage('No files found')
                return
            }
            
            if (res.status === 200) {
                dispatch(fetchLogs())
            }

        } catch (e: any) {
            alertErrorMessage(e);
            // throwErrorMessage(e.response?.data?.message, e.response?.status)
        }
    }

export const downloadLog =
    (log: ILogFile): any =>
    async (dispatch: Dispatch<any>) => {
        try {
            const res = await axios.get(`${API}/${log.log_id}`, {
                headers: getHeaders(),
                responseType: 'blob',
            })
            
            if (res.status === 200) {
                const fileName =
                    res.headers['content-disposition']
                        ?.split('=')[1]
                        ?.split(';')[0] || `${log.from}-${log.to}.zip`

                fileDownload(res.data, fileName)

                dispatch({ type: LogsActions.DOWNLOAD_LOG_SUCCESS })
            }
        } catch (e) {
            alertErrorMessage(e);
            // throwErrorMessage(e.response?.data?.message, e.response?.status)
        }
    }
